import { render, staticRenderFns } from "./HealthChildHealthQuestion.vue?vue&type=template&id=2ad940bc&scoped=true"
import script from "./HealthChildHealthQuestion.vue?vue&type=script&lang=js"
export * from "./HealthChildHealthQuestion.vue?vue&type=script&lang=js"
import style0 from "./HealthChildHealthQuestion.vue?vue&type=style&index=0&id=2ad940bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad940bc",
  null
  
)

/* custom blocks */
import block0 from "./HealthChildHealthQuestion.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports